export default {
  title: 'AIカスタマーサービス',
  collapse: '折りたたむ',
  inputPlaceholder: '質問を入力し、Enterで送信',
  inputTip: 'メッセージを入力し、Enterキーまたは送信ボタンで送信',
  send: '送信',
  serviceShort: '客',
  querying: '{label}を照会中...',
  productInfo: '商品情報',
  orderInfo: '注文情報',
  orderDetails: '注文詳細',
  unitPrice: '価格',
  quantity: '数量',
  freight: '配送料',
  specification: '仕様',
  colour: 'カラー',
  goodsSize: 'サイズ',
  orderTime: '作成日',
  remark: '備考',
  monthlySales: '月間販売',
  error: 'エラー',
  connectionError: '接続エラー',
  networkError: 'ネットワークリクエスト失敗',
  unknown: '不明',
  searchByImage: '画像で商品検索',
  newChat: '新規会話',
  chatHistory: '履歴',
  deleteChat: '削除',
  deleteChatConfirm: 'この会話を削除しますか？',
  noHistory: '履歴がありません',
  backToChat: '戻る',
  loadingHistory: '読み込み中...',
  stopGenerate: '生成停止',
  generationStopped: '出力停止済み',
  welcome: 'こんにちは！AIカスタマーサービス小艾です。何かお手伝いできますか？',
  logisticsInfo: '配送情報',
  logisticsState: '配送状況',
  logisticsOrderNo: '注文番号',
  logisticsBatchNo: 'ロット番号',
  logisticsRecipient: '受取人',
  logisticsAddress: '配送先住所',
  orderId: 'NO',
  orderStatus: '注文ステータス',
  badCount: '不良処理中数量',
  waitBoxCount: '箱詰め待ち数量',
  exchangCount: '交換中数量',
  refundCount: '返品数',
  reissueCount: '再発送中数量',
  destroyCount: '廃棄数',
  netWeight: '正味重量',
  receiveTime: '到着日',
  sendTime: '発送日',
  goodsNumber: '貨物数',
  goodsSku: '商品SKU',
  domesticTrackingNo: '国内追跡番号',
  trackingNo: '追跡番号',
  clientManagerUserName: '担当者',
  checkLabel: '検品ラベル',
  customerRemark: 'ユーザー備考',
  recipientName: '受取人',
  phone: '電話番号',
  zipCode: '郵便番号',
  address: '住所',
  productPrice: '商品費',
  agentServiceFee: '代理購入手数料',
  chineseFreight: '国内配送料',
  chinaFreight: '中国配送料',
  inspectionFee: '検品料',
  labelFee: 'ラベル料',
  problemHandlingFee: '異常処理料',
  returnFee: '返品送料',
  categoryFee: '倉庫保管費',
  exchangeRate: '為替レート',
  exchangeInspectionFee: '交換検品料',
  total: '合計',
  yuan: '元',
  containerInfo: 'ロット情報',
  containerOrderInfo: 'コンテナオーダー情報',
  badOrderInfo: '不良注文情報',
  categoryFlag: '無料倉庫保管の可否',
  goodsNameCus: '品名',
  chineseFreightFee: '中国配送料',
  locatorNo: 'ロケーション',
  putIntent: '包装意向',
  inspection: '検品',
  containerBatchNo: '箱詰め番号',
  containerState: 'ステータス',
  createTime: '作成日',
  sendTime: '発送日',
  boxesCount: '箱数',
  weight: '重量',
  logisticeCompany: '国際物流',
  importCode: '輸入商コード',
  importInfo: '輸入商情報',
  senderName: '輸入商',
  senderZipCode: '輸入商郵便番号',
  senderAddress: '輸入商住所',
  receiverInfo: '受取人情報',
  receiveInfo: '受取情報',
  zipCode: '受取人郵便番号',
  deliveryAddress: '受取人住所',
  settlement: '決済',
  totalAmount: '総支払額',
  orderType: '注文タイプ',
  route: 'ルート',
  airTransport: '航空便',
  seaTransport: '海上輸送',
  userId: 'ユーザーID',
  waybillNumber: '運送状番号',
  sendArea: '発送地域',
  senderInfo: '送り主情報',
  comments: '備考',
  goodsCount: '商品数量',
  containerGoodsCount: '申請数量',
  containerGoodsCountInstalled: '箱詰め数量',
  boxNum: '箱番号',
  canApplyCount: '申請可能数',
  capitalRecordInfo: '資金明細',
  tradeNo: '取引番号',
  relationOrderNo: '関連オーダー番号',
  tradeIntro: '取引の説明',
  tradeTime: '取引時間',
  tradeType: '取引タイプ',
  amount: '金額',
  balance: '残高',
  recharge: 'チャージ',
  payOrder: '受注支払',
  compensate: '補償',
  deduct: '引き落とし',
  withdrawal: '返金（現金引き出し）',
  typeDetail1: 'チャージ',
  typeDetail2: '梱包伝票支払',
  typeDetail2plus: '国際送料返金',
  typeDetail3: '受注支払',
  typeDetail4: '補償',
  typeDetail5: '引き落とし',
  typeDetail6: '返金（現金引き出し）',
  typeDetail7: '購入済控除',
  typeDetail8: '返品返金',
  typeDetail9: '異常控除',
  typeDetail10: '請求書の支払',
  typeDetail11: '倉庫保管費',
  typeDetail12: '検品オプション料金控除',
  typeDetail13: '購入返金を取り消す',
  typeDetail14: '検品払い戻しを取り消す',
  typeDetail15: '交換詳細検品料',
  typeDetail16: '倉庫保管費',
  typeDetail16plus: '倉庫保管料の払い戻し',
  orderStatus0: '到庫待ち',
  orderStatus1: '購入待ち',
  orderStatus2: '購入完了',
  orderStatus3: '見積り中',
  orderStatus4: '到庫済み',
  orderStatus5: '支払待ち',
  orderStatus8: '検品中',
  orderStatus12: '検品完了',
  orderStatus16: '倉庫保管中',
  orderStatus20: '出荷申請',
  orderStatus24: '不良待ち処理',
  orderStatus26: '不良却下',
  orderStatus28: '交換返品待ち',
  orderStatus32: '交換到着待ち',
  orderStatus36: '一部返品待ち',
  orderStatus40: '再発送到着待ち',
  orderStatus44: '支払待ち',
  orderStatus48: '発送待ち',
  orderStatus52: '発送済み',
  orderStatus56: 'キャンセル済み',
  orderStatus60: '返品申請中',
  orderStatus64: '返品支払待ち',
  orderStatus68: '返品待ち',
  orderStatus72: '返品済み',
  orderStatus76: '廃棄申請中',
  orderStatus80: '廃棄支払待ち',
  orderStatus82: '一部廃棄待ち',
  orderStatus83: '廃棄待ち',
  orderStatus84: '廃棄済み',
  orderStatus88: '検品完了',
  orderStatus89: '購入不可',
}